module.exports = __webpack_public_path__ + "static/collideoscope-c1a39cb4b4f9f5755ef2fe893cad4606.gif";